import React from 'react'
import {connect, RootStateOrAny} from "react-redux";
import ISettings from "../../model/interface/ui/ISettings";
import {Divider} from "antd";
import {IAppState} from "../../redux/store";
import LocaleText from "../app/settings/dictionary/LocaleText";

interface IProps {
	settings: ISettings,
	version: string
}
interface IState {}

class Footer extends React.Component<IProps, IState> {
	render() {
		const {ui} = this.props.settings
		const {supportPhone, supportMail, footerText} = ui
		return (
			<footer className="footer" style={{minHeight: 60, height: '60px !important'}}>
				<span>
					{footerText && (<>{footerText} <Divider type={"vertical"} /></>)}
					<span className="font-weight-semibold">ProCES</span> <LocaleText code={'footer.version'} fallback={'verze'}/> {this.props.version}
				</span>
				{(supportMail || supportPhone) && (
					<div>
						<span className={"mr-2"}><LocaleText code={'footer.help-contact'} fallback={'Kontakt na podporu'}/>:</span>
						{supportPhone && (
							<a className="text-gray" href={"tel:"+supportPhone.replace(/\s/g,'')}>{supportPhone}</a>
						)}
						{supportPhone && supportMail && <Divider type={"vertical"} />}
						{supportMail && (
							<a className="text-gray" href={"mailto:"+supportMail}>{supportMail}</a>
						)}
						{/*<a className="text-gray" href="/#" onClick={e => e.preventDefault()}>Term & Conditions</a>*/}
						{/*<span className="mx-2 text-muted"> | </span>*/}
						{/*<a className="text-gray" href="/#" onClick={e => e.preventDefault()}>Privacy & Policy</a>*/}
					</div>
				)}
			</footer>
		);
	}
}

const mapStateToProps = (state: IAppState) => {
	return {
		version: state.setup.version
	}
}


const mapDispatchToProps = (dispatch: any) => {
	return {
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Footer)